import moment from 'moment';
import React, { Component, Fragment } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { get } from '../../../server/actions';
import { showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import './customReactDatepicker.css';
import './reports.css';
import ClaimReportIcon from './../../../assets/img/mm/icon-2.png';
class BasicClaim extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: props.reportDefaultDate || new Date(),
            endDate: props.reportDefaultDate || new Date(),
            data: [],
            userInfo: getLoginDistrictInfo(),
            reportType: 'Federal',
            reportFor: 'Lunch'
        }
    }
    componentWillUnmount = () => {
        // this.bindData();
    }
    bindData = () => {
        const districtID = this.state.userInfo.districtId;
        let schoolID = parseInt(this.props.selectSchool);
        const s_d_id = schoolID > 0 ? schoolID : districtID;
        const isSchool = schoolID > 0 ? true : false;
        const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear;
        let start = moment(this.state.startDate).format('YYYY-MM-DD') + "T00:00:00";
        let end = moment(this.state.endDate).format('YYYY-MM-DD') + "T23:59:59";
        let _url = '';
        if (schoolID > 0) {
            _url = '/reports/basicClaimReport?mealSchoolId=' + schoolID + '&districtId=' + districtID
                + '&startDate=' + moment(start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                '&schoolYear=' + schoolYear + '&itemType=' + this.state.reportFor + '&isState=' + (this.state.reportType == 'State' ? 'true' : 'false') + '&access_token=';
        } else {
            _url = '/reports/basicClaimReport?districtId=' + districtID
                + '&startDate=' + moment(start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                '&schoolYear=' + schoolYear + '&itemType=' + this.state.reportFor + '&isState=' + (this.state.reportType == 'State' ? 'true' : 'false') + '&access_token=';
        }
        this.setState({ loading: true })
        get(_url).then((response) => {
            if (!response.ok) {
                if (response.status === 417 || response.status === 422) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                _addNotificationError(res.statusMessage, this.props)
                throw Error(res.errorMessage);
            } else if (res.statusCode === 422) {
                throw Error(res.statusMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = "BasicClaimReport";
            showFile(blob, filename);
            this.setState({ loading: false })
        }).catch((error) => {
            let msg = ''
            if (typeof error === 'string') {
                msg = error;
            } else {
                msg = error.message;
            }
            _addNotificationError(msg, this.props);
            this.setState({ loading: false })
        }
        );
    }
    render() {
        const { startDate, endDate, reportType, reportFor, userInfo } = this.state;
        const { stateIncomeEligEnabled } = userInfo || {};
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget">
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={ClaimReportIcon} />
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>Basic Claim</b></span>
                                </div>
                            </div>
                            <div className="reportCard-widget-meeting-points">
                                <div className="row form-group">
                                    <label class="col-sm-5 control-label">Report Type</label>
                                    <div className="col-sm-7">
                                        <select className='form-control' value={reportType} onChange={(e) => {
                                            this.setState({ reportType: e.target.value })
                                        }}>
                                            <option>Federal</option>
                                            {stateIncomeEligEnabled && <option>State</option>}
                                        </select>
                                    </div>
                                </div>
                                <div className="reportCard-widget-meeting-points">
                                    <div className="row form-group">
                                        <label class="col-sm-5 control-label">Report For</label>
                                        <div className="col-sm-7">
                                            <select className='form-control' value={reportFor} onChange={(e) => {
                                                this.setState({ reportFor: e.target.value })
                                            }}>
                                                <option>Lunch</option>
                                                <option>Breakfast</option>
                                                <option>Snack</option>
                                                <option>Dinner</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="row form-group">
                                    <label class="col-sm-5 control-label">Start Date</label>
                                    <div className="col-sm-7">
                                        <DatePicker wrapperClassName="fullWidthDatepicker"
                                            selected={startDate}
                                            onChange={(date) => {
                                                this.setState({ startDate: date });
                                            }} className='form-control form-control-sm' />
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label class="col-sm-5 control-label">End Date</label>
                                    <div className="col-sm-7">
                                        <DatePicker wrapperClassName="fullWidthDatepicker"
                                            selected={endDate}
                                            onChange={(date) => {
                                                this.setState({ endDate: date });
                                            }} className='form-control form-control-sm' />
                                    </div>
                                </div>
                                <div className='reportCard-widget-meeting-action'>
                                    <div className="form-group">
                                        <button type='button' className='btn btn-sm btn-success' style={{ margin: '0px' }} onClick={() => {
                                            this.bindData()
                                        }}>
                                            Download Report
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>



                </div>
            </Fragment>
        );
    }
}

export default BasicClaim;


// WEBPACK FOOTER //
// ./src/components/District/Reports/basicClaim.js